import React from "react";
import { TagProps } from "../tag";
import cn from "clsx";
import { ImageModule, ImageModuleProps } from "../image-module";
import { Heading } from "../typography/heading";
import { Text } from "../typography/text";
import { TagCollection } from "../tag-collection";
import { SanityImage } from "../image/image-types";

export type TeaserProps = {
  variant?: "primary" | "secondary";
  tags?: TagProps[] | string[];
  title?: string;
  lead?: string;
  contentType?: string;
  url: string;
  image?: {
    src?: SanityImage | string | undefined;
    alt?: string;
  };
  imageSize?: "small" | "large";
  columns?: number;
  imageStyle?: Exclude<
    ImageModuleProps["variant"],
    | "dome-narrow"
    | "dome-wide"
    | "half-moon-left"
    | "half-moon-right"
    | "half-moon-left-wide"
    | "pill"
  >;
} & React.ButtonHTMLAttributes<HTMLDivElement>;

const Teaser = React.forwardRef<HTMLDivElement, TeaserProps>(
  (
    { className, image, tags, lead, contentType, url, columns, ...props },
    ref
  ) => {
    return (
      <a href={url} className={cn("in-teaser")}>
        <div className={cn("in-teaser__image-container")}>
          <ImageModule
            className={cn(
              "in-teaser__image",
              `in-teaser__image--${props.imageStyle}`,
              `in-teaser__image--${props.imageSize}`
            )}
            variant={props.imageStyle}
            src={image?.src}
            alt={image?.alt}
            sizes={
              props.imageSize === "small"
                ? "10vw"
                : columns === 2
                ? "(min-width: 1024px) 40vw, (min-width: 768px) 40vw, 90vw"
                : columns === 3
                ? "(min-width: 1024px) 30vw, (min-width: 768px) 40vw, 90vw"
                : "(min-width: 1024px) 15vw, (min-width: 768px) 40vw, 90vw"
            }
          />
        </div>
        {contentType && (
          <div className="in-teaser__content-type">{contentType}</div>
        )}
        <div className={cn("in-teaser__textual__content", className)}>
          <Heading
            as="h3"
            size={props.variant == "primary" ? "h4" : "h5"}
            className={cn(
              "in-teaser__title",
              contentType ? "" : "in-teaser__title__no-content-type"
            )}
          >
            {props.title}
          </Heading>
          {lead && (
            <Text variant={"paragraph"} className="in-teaser__lead">
              {lead}
            </Text>
          )}
          {tags && (
            <TagCollection className="in-teaser__tag-collection" tags={tags} />
          )}
        </div>
      </a>
    );
  }
);

export default Teaser;
export { Teaser };
